import React from "react";
import LandingAuthForm from "@/widgets/landing/ui/LandingAuthForm";

type AuthFormProps = {
  isVisible: boolean;
};

function DemoAuthForm({ isVisible }: AuthFormProps) {
  if (!isVisible) {
    return null;
  }

  return (
    <div className="w-full animate-fade-in main:w-[70%]">
      <div className="tablet:pl-[86px] main:pl-[138px]">
        <LandingAuthForm />
      </div>
    </div>
  );
}

export default DemoAuthForm;
